import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable()
export class UpdateApplication {

    //updates: SwUpdate;

    constructor(private updates: SwUpdate) {

    }


    public checkForAppUpdates() {

        console.log("Check for updates initialised");
        //interval(6 * 60 * 60).subscribe(() => updates.checkForUpdate());
        // this.updates = updates;

        this.updates.available.subscribe(event => {
            console.log("subscribed to available updates");
            if (event.current == undefined) {
                console.log("LogUpdateService: Current Version undefined");
                console.log(event);
            }
            else {
                console.log('LogUpdateService: Current version is ', event.current);
            }
            if (event.available == undefined) {
                console.log("LogUpdateService: Available Version undefined");
                console.log(event);
            }
            else {
                console.log('LogUpdateService: Available version is ', event.available);
            }
            console.log("Activate Update");
            this.updates.activateUpdate().then(() => document.location.reload());
        });

        this.updates.activated.subscribe(event => {
            console.log("subscribed to activated updates");
            if (event.previous == undefined) {
                console.log("LogUpdateService: Previous Version undefined");
                console.log(event);
            } else {
                console.log('LogUpdateService: Previous version was ', event.previous);
            }
            if (event.current == undefined) {
                console.log("LogUpdateService: New Version undefined");
                console.log(event);
            } else {
                console.log('LogUpdateService: New version is ', event.current);
            }
        });

        console.log("Check for updates");
        this.updates.checkForUpdate();
    }

}